module.exports = __webpack_public_path__ + "static/media/impossible.39e81c97.png";